module.exports = __webpack_public_path__ + "img/pic16.83bca3fc.png";